/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { LangleyTopBar } from "components/header/top-bar";
import { HeaderNavBar } from "components/header/header-nav-bar";

const Header = () => {

    return (
        <>
            <LangleyTopBar />
            <HeaderNavBar />
        </>
    );
};

export { Header };
